import { useLocalization } from "@fluent/react";
import { Toggle } from "@narmi/design_system";
import styles from "./ColumnMappingScreen.module.scss";

type FileInfoCardProps = {
  fileName: string;
  columnCount: number;
  rowCount: number;
  hasHeaderRow: boolean;
  onToggleHeaderRow: (hasHeader: boolean) => void;
};

const FileInfoCard = ({
  fileName,
  columnCount,
  rowCount,
  hasHeaderRow,
  onToggleHeaderRow,
}: FileInfoCardProps) => {
  const { l10n } = useLocalization();

  return (
    <div className={styles.fileInfoCard}>
      <div className={styles.fileInfoLeft}>
        <span className="narmi-icon-file-text1" />
        <div className={styles.fileInfoText}>
          <div className={`${styles.fileName} fontWeight--semibold`}>
            {fileName}
          </div>
          <div className="fontSize--s fontColor--secondary">
            {l10n.getString("column-mapping-file-stats", {
              columnCount,
              rowCount,
            })}
          </div>
        </div>
      </div>
      <div className={styles.fileInfoRight}>
        <Toggle
          isActive={hasHeaderRow}
          onChange={(isActive: boolean) => onToggleHeaderRow(isActive)}
          label={l10n.getString("column-mapping-has-header-row")}
        />
      </div>
    </div>
  );
};

export default FileInfoCard;
